import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrimWhitespacePipe } from './trim-white-space.pipe';

@NgModule({
  declarations: [TrimWhitespacePipe],
  imports: [CommonModule],
  exports: [TrimWhitespacePipe]
})
export class TrimWhitespaceModule {}
